// Legal content for Privacy Policy & Terms of Use (AR / KU / EN)
const AR = {
  privacy: {
    title: "سياسة الخصوصية",
    updated: "2026",
    sections: [
      { h: "مقدمة", p: "تحترم شركة مدينتي لتقنيات المعلومات والحلول الذكية خصوصية زوّار موقعها، وتلتزم بحماية البيانات الشخصية التي تتم مشاركتها معنا." },
      { h: "المعلومات التي نجمعها", p: "نجمع المعلومات التي تقدّمها طوعًا عند تعبئة نماذج التواصل أو طلب عرض فني، مثل الاسم ورقم الهاتف والبريد الإلكتروني واسم الجهة وتفاصيل مشروعك." },
      { h: "كيفية استخدام المعلومات", p: "نستخدم بياناتك للرد على استفساراتك، وإعداد العروض الفنية، وتحسين خدماتنا. لا نبيع بياناتك أو نشاركها مع أطراف ثالثة لأغراض تسويقية." },
      { h: "حماية البيانات", p: "نطبّق إجراءات أمنية تقنية وتنظيمية مناسبة لحماية بياناتك من الوصول أو الاستخدام غير المصرّح به." },
      { h: "ملفات تعريف الارتباط (Cookies)", p: "قد نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح وتحليل أداء الموقع. يمكنك التحكم بها من إعدادات متصفحك." },
      { h: "حقوقك", p: "يحق لك طلب الاطلاع على بياناتك أو تصحيحها أو حذفها عبر التواصل معنا على 07826699000." },
      { h: "التواصل", p: "لأي استفسار بخصوص سياسة الخصوصية، تواصل معنا عبر البريد madenati@dlr.iq أو الهاتف 07826699000." },
    ],
  },
  terms: {
    title: "شروط الاستخدام",
    updated: "2026",
    sections: [
      { h: "قبول الشروط", p: "باستخدامك لموقع مدينتي فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا لم توافق عليها، يُرجى عدم استخدام الموقع." },
      { h: "استخدام الموقع", p: "يُمنع استخدام الموقع لأي غرض غير قانوني أو بطريقة قد تُلحق الضرر بالموقع أو تعطّل عمله أو تنتهك حقوق الآخرين." },
      { h: "الملكية الفكرية", p: "جميع المحتويات والتصاميم والشعارات والعلامات التجارية الظاهرة على الموقع مملوكة لشركة مدينتي ولا يجوز استخدامها دون إذن مسبق." },
      { h: "الخدمات والعروض", p: "المعلومات المعروضة عن خدماتنا لأغراض تعريفية، وتُحدَّد التفاصيل النهائية والأسعار ضمن عرض فني رسمي بعد دراسة احتياجاتك." },
      { h: "حدود المسؤولية", p: "نبذل قصارى جهدنا لضمان دقة المعلومات، لكننا لا نتحمّل مسؤولية أي أضرار ناتجة عن استخدام الموقع أو الاعتماد على محتواه." },
      { h: "التعديلات", p: "نحتفظ بالحق في تعديل هذه الشروط في أي وقت، ويسري التعديل فور نشره على الموقع." },
      { h: "التواصل", p: "لأي استفسار بخصوص شروط الاستخدام، تواصل معنا على 07826699000." },
    ],
  },
};

const EN = {
  privacy: {
    title: "Privacy Policy",
    updated: "2026",
    sections: [
      { h: "Introduction", p: "Madinaty for Information Technology and Smart Solutions respects the privacy of its website visitors and is committed to protecting the personal data shared with us." },
      { h: "Information We Collect", p: "We collect information you voluntarily provide when filling contact forms or requesting a quote, such as your name, phone, email, organization and project details." },
      { h: "How We Use Information", p: "We use your data to respond to inquiries, prepare technical quotes and improve our services. We do not sell or share your data with third parties for marketing." },
      { h: "Data Protection", p: "We apply appropriate technical and organizational security measures to protect your data from unauthorized access or use." },
      { h: "Cookies", p: "We may use cookies to enhance browsing experience and analyze site performance. You can control them via your browser settings." },
      { h: "Your Rights", p: "You may request to access, correct or delete your data by contacting us at 07826699000." },
      { h: "Contact", p: "For any privacy inquiry, contact us at madenati@dlr.iq or 07826699000." },
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "2026",
    sections: [
      { h: "Acceptance of Terms", p: "By using the Madinaty website, you agree to these terms and conditions. If you do not agree, please do not use the site." },
      { h: "Use of the Site", p: "The site may not be used for any unlawful purpose or in a way that could harm, disable or impair the site or infringe the rights of others." },
      { h: "Intellectual Property", p: "All content, designs, logos and trademarks on the site are owned by Madinaty and may not be used without prior permission." },
      { h: "Services & Offers", p: "Information about our services is for informational purposes; final details and pricing are defined in an official quote after studying your needs." },
      { h: "Limitation of Liability", p: "We strive to ensure accuracy, but we are not liable for any damages resulting from using the site or relying on its content." },
      { h: "Changes", p: "We reserve the right to modify these terms at any time, effective upon publication on the site." },
      { h: "Contact", p: "For any inquiry regarding these terms, contact us at 07826699000." },
    ],
  },
};

const KU = {
  privacy: {
    title: "سیاسەتی تایبەتمەندی",
    updated: "2026",
    sections: [
      { h: "پێشەکی", p: "کۆمپانیای مەدینەتی ڕێز لە تایبەتمەندی سەردانکەرانی ماڵپەڕەکەی دەگرێت و پابەندە بە پاراستنی داتای کەسی." },
      { h: "چ زانیارییەک کۆدەکەینەوە", p: "ئەو زانیارییانە کۆدەکەینەوە کە بە خواستی خۆت پێمان دەدەیت لە کاتی پڕکردنەوەی فۆرمەکان، وەک ناو، تەلەفۆن، ئیمەیڵ و وردەکاری پڕۆژە." },
      { h: "چۆن زانیاری بەکاردەهێنین", p: "داتاکەت بۆ وەڵامدانەوەی پرسیارەکان و ئامادەکردنی پێشکەشکراو و باشترکردنی خزمەتگوزارییەکان بەکاردەهێنین. داتاکەت نافرۆشین." },
      { h: "پاراستنی داتا", p: "ڕێوشوێنی ئاسایشی گونجاو جێبەجێ دەکەین بۆ پاراستنی داتاکەت لە دەستڕاگەیشتنی نەشیاو." },
      { h: "کووکیز", p: "لەوانەیە کووکیز بەکاربهێنین بۆ باشترکردنی ئەزموونی گەڕان. دەتوانیت لە ڕێکخستنی وێبگەڕەکەت کۆنترۆڵیان بکەیت." },
      { h: "مافەکانت", p: "بۆت هەیە داوای بینین، ڕاستکردنەوە یان سڕینەوەی داتاکەت بکەیت لە ڕێی 07826699000." },
      { h: "پەیوەندی", p: "بۆ هەر پرسیارێک پەیوەندیمان پێوە بکە: madenati@dlr.iq یان 07826699000." },
    ],
  },
  terms: {
    title: "مەرجەکانی بەکارهێنان",
    updated: "2026",
    sections: [
      { h: "پەسەندکردنی مەرجەکان", p: "بە بەکارهێنانی ماڵپەڕی مەدینەتی، ڕازی دەبیت بەم مەرجانە. ئەگەر ڕازی نیت، تکایە ماڵپەڕەکە بەکارمەهێنە." },
      { h: "بەکارهێنانی ماڵپەڕ", p: "نابێت ماڵپەڕەکە بۆ مەبەستی نایاسایی بەکاربهێنرێت یان بەشێوەیەک کە زیان بە ماڵپەڕەکە بگەیەنێت." },
      { h: "موڵکی هزری", p: "هەموو ناوەڕۆک و دیزاین و لۆگۆکان موڵکی مەدینەتین و بەبێ مۆڵەت نابێت بەکاربهێنرێن." },
      { h: "خزمەتگوزاری و پێشکەشکراو", p: "زانیاری خزمەتگوزارییەکان بۆ ناساندنە؛ وردەکاری کۆتایی و نرخ لە پێشکەشکراوی فەرمیدا دیاری دەکرێن." },
      { h: "سنووری بەرپرسیارێتی", p: "هەوڵ دەدەین زانیاری ورد بێت، بەڵام بەرپرس نین لە هیچ زیانێک لە ئەنجامی بەکارهێنانی ماڵپەڕەکە." },
      { h: "گۆڕانکارییەکان", p: "مافی گۆڕینی ئەم مەرجانەمان هەیە لە هەر کاتێکدا، و لەگەڵ بڵاوکردنەوەیدا جێبەجێ دەبێت." },
      { h: "پەیوەندی", p: "بۆ هەر پرسیارێک پەیوەندیمان پێوە بکە: 07826699000." },
    ],
  },
};

export const legalContent = { ar: AR, en: EN, ku: KU };
